var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLabProfileListing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lab-profile-listing",
    transform: "translate(-360.5 -299.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 40,
    height: 40,
    rx: 5,
    transform: "translate(360.5 299.5)",
    fill: "#faf3ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lab-icon",
    d: "M12.835,2.233,15.97,7.664a.964.964,0,0,1-.353,1.317L14.363,9.7l.966,1.671-1.671.965-.965-1.672-1.253.724a.965.965,0,0,1-1.318-.353L8.35,7.969A4.83,4.83,0,0,0,5.242,14.3a4.825,4.825,0,0,1,6.517,1.286L19.175,11.3l.965,1.671-7.6,4.388a4.86,4.86,0,0,1,.106,1.012,4.811,4.811,0,0,1-.1.965h7.814v1.929H3.965a4.827,4.827,0,0,1-.183-5.528A6.755,6.755,0,0,1,7.367,6.267l-.379-.658a1.929,1.929,0,0,1,.706-2.635L10.2,1.527A1.929,1.929,0,0,1,12.835,2.233ZM7.823,15.479a2.9,2.9,0,0,0-2.73,3.859h5.46a2.9,2.9,0,0,0-2.73-3.859ZM11.165,3.2,8.659,4.644l2.653,4.595,2.506-1.447L11.165,3.2Z",
    transform: "translate(368.5 308.232)",
    fill: "#cc8552"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabProfileListing);
export default __webpack_public_path__ + "static/media/lab-profile-listing.eed0b3be650d99e7285ba3950752a789.svg";
export { ForwardRef as ReactComponent };